import Typography from '@mui/material/Typography';
import { Ellipsis } from '@openx/components-core/lib/Ellipsis/Ellipsis.tsx';

type GeoRegionCellProps = {
  value: string[];
};

export const GeoRegionCell = ({ value }: GeoRegionCellProps) => {
  return (
    <Typography component="div" data-test="geo-region-cell">
      <Ellipsis
        tooltip
        tooltipMessage={value.map(region => (
          <Typography component="span" variant="body2" key={region}>
            {region} <br />
          </Typography>
        ))}
        tooltipPlacement="bottom-end"
        detectTooltipResize
        width="100%"
        data-test="geo-region-cell-ellipsis"
      >
        {value.join(', ').toString()}
      </Ellipsis>
    </Typography>
  );
};
